module.exports = __webpack_public_path__ + "assets/background.47b0e5b8a54f3c5ff90cb75ca8a9175f.jpg";